import Button from '@/components/UI/Button';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';

interface CashAssetsProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const CashAssets = ({ onNext, onPrevious }: CashAssetsProps) => {
  return (
    <div className='p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden'>
      <div>
        <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Cash Assets & Statements</h3>
        <p className='mt-2 text-sm text-gray-600'>
          Provide two (2) months of complete statements for each associated account. Check each item as you gather it.
        </p>
      </div>

      <div className='space-y-6'>
        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>
                Two (2) months complete statements for each associated checking/savings account
              </h4>
              <p className='text-sm text-gray-500 mt-1'>Upload statements from traditional bank accounts</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.checkingSavingsStatements'
            label='Checking/Savings Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose bank statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated Cash Index account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload Cash Index transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.cashAppStatements'
            label='Cash Index Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose Cash Index statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated PayPal account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload PayPal transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.payPalStatements'
            label='PayPal Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose PayPal statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated Venmo account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload Venmo transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.venmoStatements'
            label='Venmo Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose Venmo statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated Zelle account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload Zelle transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.zelleStatements'
            label='Zelle Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose Zelle statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated Google Pay account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload Google Pay transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.googlePayStatements'
            label='Google Pay Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose Google Pay statement files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Two (2) months statements for each associated Revolut account</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload Revolut transaction statements</p>
            </div>
          </div>
          <HookFileInput
            name='cashAssets.revolutStatements'
            label='Revolut Statements'
            multiple
            customClassName='mt-4'
            placeholder='Choose Revolut statement files or drag and drop'
          />
        </div>
      </div>

      <div className='flex gap-4 justify-end mt-8'>
        <Button label='Previous' btnStyle='neutral' type='button' onClick={onPrevious} />
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
};
